import ApiService from '../apiservice'

class DecisaoService extends ApiService {
  constructor() {
    super('/decisao');
  }

  cadastrar(decisao) {
    return this.post('/',decisao);
  }

  listar(processo) {
    return this.get(`/consulta-por-processo/${processo}`);
  }

  consultar(codigo) {
    return this.get(`/por-codigo/${codigo}`);
  }

  alterar(decisao) {
    return this.put('/',decisao);
  }

  excluir(codigo) {
    return this.delete(`/${codigo}`);
  }
}

export default DecisaoService;